<div class="permission-denied">
  <h1>Permission Denied</h1>
  <p>Sorry, you don't have permission to access this page.</p>
  <a (click)="navigateToFirstList()">Go Dashboard</a>
</div>
